import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Icon } from 'components/shared/Icon/Icon'

import styles from './IconWithText.module.scss'

export const IconWithText = ({
  children,
  icon,
  iconClassName = undefined,
  size = 24,
  textClassName = undefined,
}) => (
  <Box align="center" className={styles.container} tagName="span">
    {icon ? (
      <Icon
        className={cx(styles.icon, { [iconClassName]: Boolean(iconClassName) })}
        {...{ icon, size }}
      />
    ) : null}
    <p className={cx(styles.text, { [textClassName]: Boolean(textClassName) })}>
      {children}
    </p>
  </Box>
)
